import moment from "moment";

moment.locale("fr");

export default {
	titre: "",
	sous_titre: "",
	residence: "Résidence étudiée",
	statistical_data_date: moment().format(),
	kyaneos_data_date: moment().format(),
	yanport_data_date: moment().format(),
	parameters: {},
	editor_comment: "",
	cartographie: {
		references_prix: [],
		hidden_poi: []
	},
	localisation_projet: {
		intro_projet: "Entrez ici votre description de la demande de CDC Habitat<br><br>",
		image_carte: {
			src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0}
		},
		source_carte: "Source: MapBox Adequation / ....",
		images: [
			{
				src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
				description: "description image 1",
			},
			{
				src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
				description: "description image 2",
			},
		],
		visite_site: "oui/non",
		projet_ref_1: "opération comparable 1",
		projet_ref_2: "opération comparable 2",
		projet_ref_3: "opération comparable 3",
		projet_ref_4: "opération comparable 4",
		notes: {
			accessibilite: "0",
			commerces_equipements_services: "0",
			notoriete_residentielle: "0",
			environnement_bati_vue_degagement: "0",
			espaces_verts: "0",
			nuisances: "0",
		},
		objet_demande_cdchabitat: false,
		secteur_pnru: false,
		attractivite: {
			livraison: "0",
			a_terme: "0",
		},
		analyse_site: "Rédigez ici votre analyse du site",
		titre_photo1: "saisir le titre",
		titre_photo2: "saisir le titre",
	},
	dynamique_territoriale: {
		label_objectifs_plh: "Objectifs PLH — [périmètre choisi]",
		total_logements_annuel: "-1",
		total_logements_locatif_social: "-1",
		total_logements_pls: "-1",
		total_logements_locatif_intermediaire: "-1",
		dynamisme_sociodemographique: "0",
		dynamisme_construction: "0",
	},
	promotion: {
		zone_geo: "",
		zone_geo_quartier: "",
		quartier_data: {},
		commentaire: "Commentaire de la section promotion",
		operations_reference: {
			hide_aide_column: false,
			obs: {
				t1: {
					surface: "0",
					part: "0",
					mean_PUM_libre: "0",
					mean_PUM_aide: "0",
				},
				t2: {
					surface: "0",
					part: "0",
					mean_PUM_libre: "0",
					mean_PUM_aide: "0",
				},
				t3: {
					surface: "0",
					part: "0",
					mean_PUM_libre: "0",
					mean_PUM_aide: "0",
				},
				t4: {
					surface: "0",
					part: "0",
					mean_PUM_libre: "0",
					mean_PUM_aide: "0",
				},
				t5: {
					surface: "0",
					part: "0",
					mean_PUM_libre: "0",
					mean_PUM_aide: "0",
				},
			},
			non_obs: [
				{
					name: "operation #1",
					nb_lgt: "0",
					price: "0",
				},
				{
					name: "operation #2",
					nb_lgt: "0",
					price: "0",
				},
				{
					name: "operation #3",
					nb_lgt: "0",
					price: "0",
				},
			],
		},
		last_year_period: "",
		manual_KPI: {},
		manual_nature_acquereurs: [],
		manual_volume_prix: [],
		manual_duree_commercialisation: [],
		prix_ancien_hors_stationnement: "0",
	},
	marche_locatif: {
		zone_geo: "commune",
		commentaire: "Commentaire de la section Marché Locatif",
		dynamisme_construction_locative_libre_2017: "0",
		dynamisme_construction_locative_libre_2020: "0",
		loyers_neufs: {
			t1: {
				type: "T1",
				surface_habitable_min: "",
				surface_habitable_max: "",
				loyer_hc_hs_min: "",
				loyer_hc_hs_max: "",
				loyer_m2_min: "",
				loyer_m2_max: "",
			},
			t2: {
				type: "T2",
				surface_habitable_min: "",
				surface_habitable_max: "",
				loyer_hc_hs_min: "",
				loyer_hc_hs_max: "",
				loyer_m2_min: "",
				loyer_m2_max: "",
			},
			t3: {
				type: "T3",
				surface_habitable_min: "",
				surface_habitable_max: "",
				loyer_hc_hs_min: "",
				loyer_hc_hs_max: "",
				loyer_m2_min: "",
				loyer_m2_max: "",
			},
			t4: {
				type: "T4",
				surface_habitable_min: "",
				surface_habitable_max: "",
				loyer_hc_hs_min: "",
				loyer_hc_hs_max: "",
				loyer_m2_min: "",
				loyer_m2_max: "",
			},
			t5: {
				type: "T5",
				surface_habitable_min: "",
				surface_habitable_max: "",
				loyer_hc_hs_min: "",
				loyer_hc_hs_max: "",
				loyer_m2_min: "",
				loyer_m2_max: "",
			},
		},
	},
	budget_menages: {
		menages: {
			p1: {
				repartition: "",
				type_associe: "1",
				revenu_max: "",
				loyer_max: "",
				loyer_local: "",
			},
			p2_3: {
				repartition: "",
				type_associe: "2",
				revenu_max: "",
				loyer_max: "",
				loyer_local: "",
			},
			p4_5: {
				repartition: "",
				type_associe: "3",
				revenu_max: "",
				loyer_max: "",
				loyer_local: "",
			},
		},
		commentaire: "Entrez ici le commentaire sur les budgets des ménages",
	},
	synthese: {
		priorite: "",
		nb_location_tables: "1",
		location_1_lines: "4",
		location_1: [
			{
				type: "T1",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "T2",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "T3",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "T4",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
		],
		stationnements_1: [
			{
				id: "parking_ext",
				label: "Parking extérieur",
				rent_price: "20",
				sale_price: "0",
				checked: true,
			},
			{
				id: "parking_int",
				label: "Parking intérieur",
				rent_price: "0.0",
				sale_price: "0",
				checked: false,
			},
			{
				id: "box",
				label: "Box",
				rent_price: "60",
				sale_price: "0",
				checked: true,
			},
			{
				id: "autre",
				label: "Autre",
				rent_price: "60",
				sale_price: "0",
				checked: false,
			}
		],
		location_2_lines: "4",
		location_2: [
			{
				type: "T1",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "T2",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "T3",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "T4",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
		],
		stationnements_2: [
			{
				id: "parking_ext",
				label: "Parking extérieur",
				rent_price: "20",
				sale_price: "0",
				checked: true,
			},
			{
				id: "parking_int",
				label: "Parking intérieur",
				rent_price: "0.0",
				sale_price: "0",
				checked: false,
			},
			{
				id: "box",
				label: "Box",
				rent_price: "60",
				sale_price: "0",
				checked: true,
			},
			{
				id: "autre",
				label: "Autre",
				rent_price: "60",
				sale_price: "0",
				checked: false,
			}
		],
		location_3_lines: "4",
		location_3: [
			{
				type: "T1",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "T2",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "T3",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "T4",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
			{
				type: "",
				nb: "0",
				surf_hab: "0",
				loyer_hc_hs: "0",
			},
		],
		stationnements_3: [
			{
				id: "parking_ext",
				label: "Parking extérieur",
				rent_price: "20",
				sale_price: "0",
				checked: true,
			},
			{
				id: "parking_int",
				label: "Parking intérieur",
				rent_price: "0.0",
				sale_price: "0",
				checked: false,
			},
			{
				id: "box",
				label: "Box",
				rent_price: "60",
				sale_price: "1000",
				checked: true,
			},
			{
				id: "autre",
				label: "Autre",
				rent_price: "60",
				sale_price: "0",
				checked: false,
			}
		],
		afficher_individuel_avec_stat: true,
		hypotheses_prix: {
			logements_sans_parking: "",
			logements_avec_parking: "",
			// stationnements_prix: "",
			// stationnements_type: "",
		},
		dynamisme_attractivite: "0",
		potentiel_locatif_libre: "0",
		potentiel_locatif_intermediraire: "0",
		situation_promotion: "0",
		valorisation_patrimoniale: "0",
		synthese_generale: "0",
		commentaire: "Conclusion & recommandations générales",
	},
	gie: {
		sectionAnalyseDeSite: {
			titre: "",
			images: [
				{
					src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
					description: "Description image 1",
				},
				{
					src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
					description: "Description image 2",
				},
				{
					src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
					description: "Description image 2",
				}
			],
			titre_photo1: "Saisir le titre",
			titre_photo2: "Saisir le titre",
			titre_photo3: "Saisir le titre",

			commentaire: "Commentaire",
			notes: {
				accessibilite: "0",
				commerces_equipements_services: "0",
				notoriete_residentielle: "0",
				environnement_bati_vue_degagement: "0",
				espaces_verts: "0",
				nuisances: "0",
				attractivite_actuelle: "0",
				attractivite_court_terme: "0"
			}
		},
		sectionDynamiqueTerritoriale: {
			titre: "",
		},
		sectionCaracteristiquesResidence: {
			titre: "",
			nb_location_tables: "1",
			surface_loyer_table_lines: "4",
			surface_loyer_loyer_m2: "0",
			surface_loyer_table: [
				{
					type: "T1",
					nb: "0",
					surf_hab: "0",
					loyer_m2: "0",
				},
				{
					type: "T2",
					nb: "0",
					surf_hab: "0",
					loyer_m2: "0",
				},
				{
					type: "T3",
					nb: "0",
					surf_hab: "0",
					loyer_m2: "0",
				},
				{
					type: "T4",
					nb: "0",
					surf_hab: "0",
					loyer_m2: "0",
				},
				{
					type: "",
					nb: "0",
					surf_hab: "0",
					loyer_m2: "0",
				},
				{
					type: "",
					nb: "0",
					surf_hab: "0",
					loyer_m2: "0",
				},
				{
					type: "",
					nb: "0",
					surf_hab: "0",
					loyer_m2: "0",
				},
				{
					type: "",
					nb: "0",
					surf_hab: "0",
					loyer_m2: "0",
				},
				{
					type: "",
					nb: "0",
					surf_hab: "0",
					loyer_m2: "0",
				},
			],
			epoque_construction: "2000",
			presence_gardien: undefined,
			portail_securise: undefined,
			entree_securisee: undefined,
			taille_surface_habitable: "Standard",
			taille_surface_exterieure: "Standard",
			etat_parties_communes_ext: "Bon",
			etat_parties_communes_int: "Bon",
			mode_chauffage: "Collectif",
			energie_utilise: "Électrique",
			menuiserie: "Bois",
			cave: undefined,
			parking: "Aucun",
			pictures: {
				titre_photo1: "saisir le titre",
				titre_photo2: "saisir le titre",
				titre_photo3: "saisir le titre",
				images: [
					{
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
						description: "description image 1",
					},
					{
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
						description: "description image 2",
					},
					{
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
						description: "description image 3",
					},
				],
			},
			attractivite_residence: "2",
			commentaire: "Commentaire",
		},
		sectionDynamiqueMarcheResidentiel: {
			titre: "",
			commentaire: "Commentaire",
			prix_stationnement: "0",
			marche_revente_table_lines: "5",
			marche_revente_table: [
				{
					type: "T1",
					intensite_transactions: "+/-",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "T2",
					intensite_transactions: "+/-",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "T3",
					intensite_transactions: "+/-",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "T4",
					intensite_transactions: "+/-",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "T5",
					intensite_transactions: "+/-",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "",
					intensite_transactions: "+/-",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "",
					intensite_transactions: "+/-",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "",
					intensite_transactions: "+/-",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "",
					intensite_transactions: "+/-",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "",
					intensite_transactions: "+/-",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
			],
			logement_proximite_table_lines: "5",
			logement_proximite_table: [
				{
					type: "T1",
					numero: "",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
					periode_vente: "",
				},
				{
					type: "T2",
					numero: "",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
					periode_vente: "",
				},
				{
					type: "T1",
					numero: "",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
					periode_vente: "",
				},
				{
					type: "T3",
					numero: "",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
					periode_vente: "",
				},
				{
					type: "T4",
					numero: "",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
					periode_vente: "",
				},
				{
					type: "T5",
					numero: "",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
					periode_vente: "",
				},
				{
					type: "",
					numero: "",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
					periode_vente: "",
				},
				{
					type: "",
					numero: "",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
					periode_vente: "",
				},
				{
					type: "",
					numero: "",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
					periode_vente: "",
				},
				{
					type: "",
					numero: "",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
					periode_vente: "",
				},
				{
					type: "",
					numero: "",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
					periode_vente: "",
				},
			],
			tauxInteret: "1",
			dureeEmprunt: "20",
		},
		sectionCapaciteFinanciereMenages: {
			titre: ""
		},
		sectionSynthesePreconisations: {
			titre: "",
			avis_potentiel_residence: "3",
			synthese_preconisations_table_lines: "5",
			indexSelectedType: "2",
			synthese_preconisations_table: [
				{
					type: "T1",
					nb: "0",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "T2",
					nb: "0",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "T3",
					nb: "0",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "T4",
					nb: "0",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "T5",
					nb: "0",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "",
					nb: "0",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "",
					nb: "0",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "",
					nb: "0",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "",
					nb: "0",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
				{
					type: "",
					nb: "0",
					surf_hab: "0",
					prix_unit: "0",
					prix_m2: "0",
				},
			],
			positionnement_menages_pourcent: "50",
			correlation_prix_rythme_table: [
				{
					gamme_prix_bas: "0",
					gamme_prix_haut: "0",
					cibles: "Cœur de demande + invest. + accession sociale",
					concurrence: "0",
					rythme_rapide: "0",
					rythme_normal: "0",
					rythme_lent: "0",
					estimation_duree_comm: "0"
				},
				{
					gamme_prix_bas: "0",
					gamme_prix_haut: "0",
					cibles: "Cœur de la demande pour ce type de produit",
					concurrence: "0",
					rythme_rapide: "0",
					rythme_normal: "0",
					rythme_lent: "0",
					estimation_duree_comm: "0"
				},
				{
					gamme_prix_bas: "0",
					gamme_prix_haut: "0",
					cibles: "Prix hors marché vs. les produits proposés",
					concurrence: "0",
					rythme_rapide: "0",
					rythme_normal: "0",
					rythme_lent: "0",
					estimation_duree_comm: "0"
				},
			],
			commentaire: "Commentaire"
		},
		sectionComplements: {
			titre: "",
			show_locaux_commerciaux_table: false,
			locaux_commerciaux_table_lines: "3",
			locaux_commerciaux_table: [
				{
					designation: "",
					base_locative: "",
					taux_rendement: "",
					valeur_capitalisee: ""
				},
				{
					designation: "",
					base_locative: "",
					taux_rendement: "",
					valeur_capitalisee: ""
				},
				{
					designation: "",
					base_locative: "",
					taux_rendement: "",
					valeur_capitalisee: ""
				},
				{
					designation: "",
					base_locative: "",
					taux_rendement: "",
					valeur_capitalisee: ""
				},
				{
					designation: "",
					base_locative: "",
					taux_rendement: "",
					valeur_capitalisee: ""
				},
				{
					designation: "",
					base_locative: "",
					taux_rendement: "",
					valeur_capitalisee: ""
				},
				{
					designation: "",
					base_locative: "",
					taux_rendement: "",
					valeur_capitalisee: ""
				},
				{
					designation: "",
					base_locative: "",
					taux_rendement: "",
					valeur_capitalisee: ""
				},
				{
					designation: "",
					base_locative: "",
					taux_rendement: "",
					valeur_capitalisee: ""
				}
			],
			show_bail_emphyteotique_table: false,
			bail_emphyteotique_table_lines: "3",
			bail_emphyteotique_table: [
				{
					valeur_sol_construction: "",
					annees_ecoulees: "",
					valeur_actuelle_droits_acquis: ""
				},
				{
					valeur_sol_construction: "",
					annees_ecoulees: "",
					valeur_actuelle_droits_acquis: ""
				},
				{
					valeur_sol_construction: "",
					annees_ecoulees: "",
					valeur_actuelle_droits_acquis: ""
				},
				{
					valeur_sol_construction: "",
					annees_ecoulees: "",
					valeur_actuelle_droits_acquis: ""
				},
				{
					valeur_sol_construction: "",
					annees_ecoulees: "",
					valeur_actuelle_droits_acquis: ""
				},
				{
					valeur_sol_construction: "",
					annees_ecoulees: "",
					valeur_actuelle_droits_acquis: ""
				},
				{
					valeur_sol_construction: "",
					annees_ecoulees: "",
					valeur_actuelle_droits_acquis: ""
				},
				{
					valeur_sol_construction: "",
					annees_ecoulees: "",
					valeur_actuelle_droits_acquis: ""
				},
				{
					valeur_sol_construction: "",
					annees_ecoulees: "",
					valeur_actuelle_droits_acquis: ""
				}
			]
		}
	},
	scpi: {
		yanport: {
			page_4: {
				localisations: [],
				type_biens: ["APARTMENT"],
				periode_analyse: "1"
			},
			page_5: {
				localisations: [],
				type_biens: ["APARTMENT"],
				periode_analyse: "1"
			}
		},
		garde: {
			code: "-",
			clientFirm: "PIERRE",
			images: [
				{
					src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
					description: "saisir le titre",
				},
			],
			company_name: "SCPI Kyaneos Pierre",
			actif_adresse: "-",
			date_valeur: "31/12/2023",
			date_visite: "31/12/2023",
			designation_adresse: "-",
			designation: "-",
			cadastres_lignes: 1,
			cadastres: [
				{
					reference: "-",
					lieudit: "-",
					contenance: "-"
				},
				{
					reference: "-",
					lieudit: "-",
					contenance: "-"
				},
				{
					reference: "-",
					lieudit: "-",
					contenance: "-"
				},
				{
					reference: "-",
					lieudit: "-",
					contenance: "-"
				},
				{
					reference: "-",
					lieudit: "-",
					contenance: "-"
				},
				{
					reference: "-",
					lieudit: "-",
					contenance: "-"
				},
				{
					reference: "-",
					lieudit: "-",
					contenance: "-"
				},
				{
					reference: "-",
					lieudit: "-",
					contenance: "-"
				},
				{
					reference: "-",
					lieudit: "-",
					contenance: "-"
				},
			],
			situation_juridique: "Pleine propriété",
			affectation_juridique: "d'habitation"
		},
		situation: {
			localisation: {
				images: [
					{
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
						description: "saisir le titre",
					},
					{
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
						description: "saisir le titre",
					},
				]
			},
			analyse: {
				commerciabilite: "0",
				accesTransport: "0",
				dynamismeEconomique: "0",
				notoriete: "0",
				commentaire: "",
			}
		},
		elements_descriptifs: {
			questions: {
				epoque: "-",
				type_produit: "-",
				nb_etages: "1",
				carac_constr: "-",
				acces_secure: "-",
				etat_general: "-",
				etat_commune: "-",
				nombre_lot: "-",
				prestations: "-",
				equipements: "-",
				chauffage: "-",
				menuiseries: "-",
				annexes: "-",
				etat: "-",
			},
			images: [
				{
					src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
					description: "saisir le titre",
				},
				{
					src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
					description: "saisir le titre",
				},
				{
					src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
					description: "saisir le titre",
				},
			],
			commentaire: "",
			budget_travaux: "0",
			description_travaux: "Insérer description",
			date_avancement_travaux: "31/12",
			immeubles_table_lignes: 6
		},
		situation_locative: {
			stock: "",
			prix: "",
			duree: "",
			commentaire_locatif: "",
			commentaire_situation_actuelle: ""
		},
		revente: {
			images: [
				{
					src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0},
					description: "localisation des transactions - données DVF",
				}
			],
			transaction_table: {
				periode: "-",
				nombre_transactions: "-",
				prix_median: "-",
				surface_mediane: "-",
				fourchette_dominante: "X - X"
			},
			offres_table_lignes: 1,
			offres_table: [
				{
					localisation: "-",
					commentaire: "-",
					surf_hab: "-",
					prix_m2: "-",
					image: {
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0}
					},
				},
				{
					localisation: "-",
					commentaire: "-",
					surf_hab: "-",
					prix_m2: "-",
					image: {
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0}
					},
				},
				{
					localisation: "-",
					commentaire: "-",
					surf_hab: "-",
					prix_m2: "-",
					image: {
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0}
					},
				},
				{
					localisation: "-",
					commentaire: "-",
					surf_hab: "-",
					prix_m2: "-",
					image: {
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0}
					},
				},
				{
					localisation: "-",
					commentaire: "-",
					surf_hab: "-",
					prix_m2: "-",
					image: {
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0}
					},
				},
				{
					localisation: "-",
					commentaire: "-",
					surf_hab: "-",
					prix_m2: "-",
					image: {
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0}
					},
				},
				{
					localisation: "-",
					commentaire: "-",
					surf_hab: "-",
					prix_m2: "-",
					image: {
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0}
					},
				},
				{
					localisation: "-",
					commentaire: "-",
					surf_hab: "-",
					prix_m2: "-",
					image: {
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0}
					},
				},
				{
					localisation: "-",
					commentaire: "-",
					surf_hab: "-",
					prix_m2: "-",
					image: {
						src: "", image_zoom: 1, image_rotation: 0, image_offset: {x: 0, y: 0}
					},
				},
			],
			commentaire: ""
		},
		evaluation: {
			commentaire_logements: "",
			commentaire_annexe: "",
			commentaire_rendement: "",
			show_annexes_commentaire: true,
			show_annexes_garages: false,
			show_annexes_locaux_commerciaux: false,
			show_annexes_bureaux: false,
			annexes_table_garages_nb_lignes: 1,
			logements: 4,
			annexes_table_garages: [
				{
					nb_lots: "1",
					valeur_unitaire: "0"
				},
				{
					nb_lots: "1",
					valeur_unitaire: "0"
				},
				{
					nb_lots: "1",
					valeur_unitaire: "0"
				},
				{
					nb_lots: "1",
					valeur_unitaire: "0"
				},
				{
					nb_lots: "1",
					valeur_unitaire: "0"
				},
				{
					nb_lots: "1",
					valeur_unitaire: "0"
				},
				{
					nb_lots: "1",
					valeur_unitaire: "0"
				},
				{
					nb_lots: "1",
					valeur_unitaire: "0"
				},
				{
					nb_lots: "1",
					valeur_unitaire: "0"
				},
			],
			annexes_table_locaux_commerciaux_nb_lignes: 1,
			annexes_table_locaux_commerciaux: [
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
			],
			annexes_table_bureaux_nb_lignes: 1,
			annexes_table_bureaux: [
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
				{
					revenus: "0",
					rendement: "0"
				},
			],
			verification_table: [
				{
					revenus: "0",
					rendement: "0",
				}
			],
			conclusion_table: {
				methode_comparaison: "0",
				show_abattement: true,
				abattement: "0",
				valeur_apres_abattement: "0",
				methode_rendement: "0",
				moyenne_retenue: "0"
			},
			date_signature: "-/-/-",
			signed: false
		}
	},
	lexique: {
		show_budget: true
	},
};
